<template>
  <SectionTransition :has-content="!!alternativeProduct">
    <div class="flex flex-wrap justify-between items-center gap-x-2">
      <span class="text-xs font-bold flex-1 min-w-fit">{{ $t('Product condition') }}</span>
      <ABWareAlternativeDropdown
        class="flex-grow w-[60%]"
        :slug="alternativeProduct?._slug || ''"
        :sku="alternativeProductSku"
        :is-aware="isAWare"
      />
    </div>
  </SectionTransition>
</template>

<script lang="ts">

import { convertAWareToBWare, convertBWareToAWare } from '~~/helpers/product/convertBWare';
import { isAWareProduct, isBWareProduct } from '~~/helpers/product/productCondition';

export default defineComponent({
  name: 'ABWareAlternative',

  props: {
    sku: {
      type: String,
      required: true,
    },
  },
  setup(props) {

    const {
      alternativeProduct,
      search,
    } = useProductAlternative(props.sku);

    const isAWare = computed(() => isAWareProduct(props.sku));
    const isBWare = computed(() => isBWareProduct(props.sku));
    const alternativeProductSku = computed(() => {

      if (isAWare.value) {

        return convertAWareToBWare(props.sku);
      
      }

      if (isBWare.value) {

        return convertBWareToAWare(props.sku);
      
      }

      return '';
    
    });

    onMounted(() => {

      if (alternativeProductSku.value) {

        search(alternativeProductSku.value);
      
      }
    
    });

    return {
      alternativeProduct,
      alternativeProductSku,
      isAWare,
    };
  
  },
});


</script>
